import type { FC } from 'react';

import { Icon, Tooltip } from '@zen/DesignSystem';

import { RejectPopover } from '../RejectPopover/RejectPopover';

interface SuggestionTextProps {
  id: string;
  onAccept: (id: string) => void;
  onReject: (id: string, reason: string) => void;
  proposedValueText: string;
}

export const SuggestionText: FC<SuggestionTextProps> = ({ id, proposedValueText, onAccept, onReject }) => {
  return (
    <div className="rounded-4xl text-transparent flex items-center px-2 gap-2 justify-between w-auto h-8 bg-sunset-base bg-clip-text mt-2">
      <Tooltip tooltipContent={proposedValueText}>
        <div className="flex items-center gap-2">
          <Icon icon="zicon-sparkles-empty" />
          <span className="font-extrabold block truncate max-w-40">{proposedValueText}</span> suggested
        </div>
      </Tooltip>
      <div className="flex items-center gap-2">
        <Icon onClick={() => onAccept(id)} className="right-4 cursor-pointer" icon="zicon-tick" />
        <RejectPopover id={id} onReject={onReject} />
      </div>
    </div>
  );
};
